import moment from "moment";
import {
  STANDARD_APP_DATE_FORMAT,
  STANDARD_APP_DATE_TIME_FORMAT,
} from "../constants/constants";

export const convertDate = (targetDate: string) => {
  let date = new Date(targetDate);

  date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

export const formatDateTimeWithLocale = (date: string | null) => {
  if (date) {
    return moment.utc(date).format("MMM DD, yyyy hh:mm A");
  } else {
    return "--";
  }
};

export const formatDate = (date: string | null | undefined) => {
  if (!date) return "";
  return moment(date).format(STANDARD_APP_DATE_FORMAT);
};

export const formatDate2 = (date: string | null) => {
  if (!date) return "";
  return moment(date).format("YYYY/MM/DD");
};

export const formatDate3 = (date: string | null) => {
  if (!date) return "";
  return moment(date).format("YYYY-MM-DD");
};

export const formatDateWithTime = (date: string) => {
  return moment(date).format(STANDARD_APP_DATE_TIME_FORMAT);
};

export const formatDateWithTimeUtc = (date: string) => {
  return moment(date).utc().format(STANDARD_APP_DATE_TIME_FORMAT);
};

export const formatDateUtc = (date: string | null) => {
  if (!date) return "";
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(date);
  if (isDateOnly) {
    return moment(date, "YYYY-MM-DD", true).format(STANDARD_APP_DATE_FORMAT);
  }

  return moment(date).utc().format(STANDARD_APP_DATE_FORMAT);
};
